module.exports = __webpack_public_path__ + "static/media/sunrise-section-header-logo.1a6c53cf.jpg";